import type { ShowcaseAd, ShowcaseProduct } from './types';

const RATIO_ORDER = ['9:16', '4:5', '1:1', '1.91:1', '16:9'] as const;

export function wallOrder(ads: ShowcaseAd[], products: ShowcaseProduct[]): ShowcaseAd[] {
  const out: ShowcaseAd[] = [];
  if (products.length === 0) return out;
  RATIO_ORDER.forEach((ratio, ri) => {
    products.forEach((_, k) => {
      const pi = (k + ri) % products.length;
      const candidates = ads.filter(a => a.ratio === ratio && a.product.id === products[pi]?.id);
      if (candidates.length) out.push(candidates[(pi + ri) % candidates.length]);
    });
  });
  return out;
}
